import { useTranslation } from 'react-i18next';
import { NewCheckbox } from '../../../../../Components/PIM/common/NewCheckbox';
import type { PanelFlagsRowProps } from './panel-flags-row.types';

function PanelFlagsRow({
  idPrefix,
  isAccordion,
  onAccordionChange,
  isVisibleToSupplier,
  onVisibleToSupplierChange,
  leading,
  trailing,
}: PanelFlagsRowProps) {
  const { t } = useTranslation('custom-module-system-canvas');
  const accordionId = `${idPrefix}-accordion`;
  const supplierId = `${idPrefix}-supplier`;

  return (
    <div className="cm-panel-flags">
      <div className="cm-panel-flags__group">
        {leading}
        <NewCheckbox
          id={accordionId}
          checked={isAccordion}
          onChange={(event) => onAccordionChange(event.target.checked)}
          label={t('CUSTOM_MODULE.SYSTEM_CANVAS.CONVERT_TO_ACCORDION')}
          labelClassName="cm-panel-flags__label"
        />
      </div>
      <div className="cm-panel-flags__group">
        <label className="cm-panel-flags__label" htmlFor={supplierId}>
          {t('CUSTOM_MODULE.SYSTEM_CANVAS.VISIBLE_TO_SUPPLIER_QUESTION')}
        </label>
        <NewCheckbox id={supplierId} checked={isVisibleToSupplier} onChange={(event) => onVisibleToSupplierChange(event.target.checked)} />
        {trailing}
      </div>
    </div>
  );
}

export default PanelFlagsRow;
